module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/报告下载端.409bef84.png";